import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../../../../app/store'
import fetchAPI from '../../../../common/fetchAPI'
import { QuickBookStateClass } from './interfaces/QuickBookStateClass'
import moment from 'moment'

const initialState: QuickBookStateClass = {
    isLoading: false,
    status: 'idle',
    quikBookLogList: [],
    selectedRecord: {},
    isReload: false,
    // startDate: (() => {
    //     const newDate = new Date();
    //     newDate.setMonth(newDate.getMonth() - 2);
    //     return newDate.toISOString();
    // })(),
    // endDate: new Date().toISOString(),
    startDate: moment().subtract(2, 'months').format("YYYY-MM-DD"),
    endDate: moment().format("YYYY-MM-DD"),
    currentPage: 1,
    pageSize: 10,
    totalItems: 0,
    start: 0,
    search: " ",
    columnIndex: 0,
    direction: "asc",
    recordsFiltered: 0,
    optionActionStatusValue: "All",
    optionActionStatusText: "All",
    optionQBEventValue: "All",
    optionQBEventText: "All",
    IsRemoveFilterSetting: true
}

interface IThunkApi {
    state: {
        quicksBookLog: QuickBookStateClass;
    },
}

export const getDataQuicksBookLogAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'quicksBookLog/v2/QBLogDatatable',
        async (arg, thunkApi) => {
            const { } = arg;
            const { ActionStatus, StartDate, EndDate, QBEvent, page, pageSize, start, Order, OrderDir, search } = arg;
            let SearchParamsValues = `${ActionStatus},${StartDate},${EndDate},${QBEvent}`;
            const response = await fetchAPI('api/v2/Logs/QBLogDatatable?SearchParamsValues=' + SearchParamsValues + '&page=' + page + '&pageSize=' + pageSize + '&start=' + start + '&Order=' + Order + '&OrderDir=' + OrderDir + '&search=' + search, 'Get', '', true, '');
            const json = await response.json();
            return json;
        }
    )

export const QuicksBookSlice = createSlice({
    name: 'quicksBookLog',
    initialState,
    reducers: {
        resetSelectedRecordObjectInState: (state) => {
            state.quikBookLogList = [];
        },
        setDateRangeValue: (state, action) => {
            const { startDate, endDate } = action.payload;
            state.startDate = startDate;
            state.endDate = endDate;
        },
        setPageSize: (state, action) => {
            state.pageSize = action.payload;
        },
        setSearchValue: (state, action) => {

            state.search = action.payload;
            state.currentPage = 1;
        },
        setSortConfig: (state, action) => {
            const { Index, Dir } = action.payload;
            state.direction = Dir;
            state.columnIndex = Index;
        },
        setStatusValue: (state, action) => {
            const { value, label } = action.payload;
            state.optionActionStatusValue = value;
            state.optionActionStatusText = label;
        },
        setQBEventValue: (state, action) => {
            const { value, label } = action.payload;
            state.optionQBEventValue = value;
            state.optionQBEventText = label;
        },
        setIsRemoveFilterSetting: (state, action) => {
            state.IsRemoveFilterSetting = action.payload;;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getDataQuicksBookLogAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(getDataQuicksBookLogAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = false;
                state.isLoading = false;
                if (JSON.parse(payload.Data.data).length === 0) {
                    state.quikBookLogList = [];
                } else {
                    state.quikBookLogList = JSON.parse(payload.Data.data);
                }
                state.selectedRecord = {};
                state.start = payload.Data.start
                state.currentPage = payload.Data.currentPage;
                state.totalItems = payload.Data.recordsTotal;
                state.recordsFiltered = payload.Data.recordsFiltered;
            })
            .addCase(getDataQuicksBookLogAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false
                state.isReload = false;
            })
    }
})

export const {
    resetSelectedRecordObjectInState, setDateRangeValue, setPageSize, setSortConfig, setIsRemoveFilterSetting, setStatusValue, setQBEventValue } = QuicksBookSlice.actions
export const ExpenseApprovalState = (state: RootState) => state.quicksBookLog
export default QuicksBookSlice.reducer